import React, { useState, useId, useEffect } from "react";
import { Container, Box, Typography, Grid, TextField, Button, Stack, Pagination } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "./Cart.css";
import cat1 from "./../assests/deal2.png";
import cat2 from "./../assests/deal3.png";
import cat3 from "./../assests/bestD2.png";
import { FiMinus, FiPlus } from "react-icons/fi";
import { useCartStore } from "../store/useCartStore";
import Loader from "../components/Loader/Loader";
import { MdDelete } from "react-icons/md";
import { IoEyeSharp } from "react-icons/io5";
import OrderHistory from "./OrderDisaplay";
import { useOrderStore } from "../store/useOrderStore";

const cartItems = {
  alignItems: "center",
  justifyContent: "space-between",
  display: "flex",
  marginBottom: "25px",
  gap: "20px",
}




const Orders = () => {
  const id = useId();
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [field, setField] = useState('');


  // Add quantity 
  const [number, setNumber] = useState(1);
  const navigate = useNavigate()
  const { getOrder, loading } = useOrderStore()

  const getCartItemFunction = async () => {
    const data = await getOrder(pageNumber, pageSize, '', '')
    if (data) {
      setTotalPages(data?.totalPages)
    }
  }

  const handleNavigate = () => {
    navigate('/checkout', { state: { throughCart: true } });
  }

  const handleChangePagination = (event, value) => {
    setPageNumber(value);
  };

  useEffect(() => {
    getCartItemFunction()
  }, [pageNumber])


  return (
    <>
      <Container sx={{
        marginBottom: "60px"
      }}>
        <Loader loading={loading} />
        <Typography sx={{
          fontSize: '30px',
          lineHeight: '28.8px',
          fontWeight: '700',
          fontFamily: `"Quicksand", sans-serif`,
          color: '#253D4E',
          paddingBottom: '16px',
          borderBottom: '1px solid #00000024',
          margin: "60px 0 30px",
          position: 'relative',
          '&::before': {
            content: `""`,
            width: '80px',
            height: '2px',
            background: '#008BFF',
            position: 'absolute',
            left: '0',
            bottom: '0',
          },
        }}>Order Details</Typography>
        <Grid
          container
          sx={{ width: "100%" }}
          columnSpacing={{ xs: 1, sm: 2, md: 4 }}
        >
          <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
            <Box
            // sx={{
            //   backgroundColor: "rgba(217, 217, 217, 0.4)",
            //   padding: "10px",
            //   borderRadius: "6px",
            // }}
            >
              <OrderHistory />

            </Box>
          </Grid>
        </Grid>
        <div
          style={{
            // width: "100vw",
            display: "flex",
            marginTop: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              onChange={handleChangePagination}
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </div>

      </Container>
    </>
  );
};

export default Orders;
